import type { Demand } from '../../gql';

import { randNumber, randUuid, randBoolean, randWord } from '@ngneat/falso';

import { mockStyleDemand } from './mockStyleDemand';

/** Will return a mocked Demand object, useful for tests etc. */
const mockDemand = (overwrite?: Partial<Demand>): Demand => {
    const baseDemand: Demand = {
        assortmentCount: randNumber({ min: 5, max: 50 }),
        demandGroupNumber: randBoolean() ? randUuid() : null,
        siteDestinationCode: randBoolean()
            ? `SD${randNumber({ min: 100, max: 999 })}`
            : null,
        siteDestinationName: randBoolean()
            ? `${randWord({ capitalize: true })} Site Destination`
            : null,
        styleCount: randNumber({ min: 1, max: 20 }),
        styleDemand: [mockStyleDemand(), mockStyleDemand()],
        totalQuantity: randNumber({ min: 5000, max: 100000 }),
    };

    return { ...baseDemand, ...overwrite };
};

export { mockDemand };
